<template lang="pug">
.frequency
  treatment-frequency-dropdown(v-if="item.editable && item.productItem.medication" :item="item" @dropdownOpenClosed="$emit('dropdownOpenClosed', $event)" @changed="$emit('changed', $event)")
  div.clickable(v-else-if="!item.editable && item.productItem.medication && item.productItem.medication.frequency")
    span.font-medium.danger500--text(v-if="item.error") {{ item.productItem.medication.frequency }}
    span(v-else) {{ item.productItem.medication.frequency }}
</template>

<script>
import TreatmentFrequencyDropdown from '@/components/clinic/consultation/treatments/treatmentTableItems/TreatmentFrequencyDropdown.vue'

export default {
  components: {
    TreatmentFrequencyDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>